import type { CellProps } from 'react-table';
import { Tags } from './Tags';
import type { ProjectsTableItem } from './interfaces';

export default function ProjectTags({ row: { original: data } }: CellProps<ProjectsTableItem>) {
  return <Tags tags={data.tags} maxTags={1} />;
}

export { ProjectTags };